import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'radar',
  templateUrl: './radar.html'
})
export class RadarChartComponent implements OnInit {


  targetScore = [80,80,80,80,80,80]

  codinClubTopicWiseMarks: any;
  list: any = [];
  marksObtained: any;
  totalMarks: any;
  perCentage: any;

  ngOnInit() {
    this.marksObtained=localStorage.getItem('marksObtained');
    var getObj = JSON.parse(localStorage.getItem('resultResponse'));
    this.perCentage=localStorage.getItem('perCentage');
    this.codinClubTopicWiseMarks = getObj;
    this.getResponse()
  }

  getResponse() {
    {
      this.codinClubTopicWiseMarks.forEach((item, index) => {
        this.list.push(item.percentage);
      });
      this.list.push(this.perCentage);
    }
  }

  public demoradarChartLabels: string[] = [ 'Terminal & GIT Commands','Programming Constructs' ,'OOPS Concepts', 'Java Programming', 'Web Development', 'Overall Score'];
  public demoradarChartData: any = [
    {

      data:this.targetScore,
      label: 'Target Score',
      backgroundColor: "rgba(0, 0, 0, 0)",
      borderColor: "#EA4335",
      pointStyle: 'circle',
      fill: false,
      radius: 3,

    },
    {
      data: this.list,
      label: 'Current Score',
      backgroundColor: "rgba(0, 0, 0, 0)",
      borderColor: "#008CFF",
      pointStyle: 'circle',
      fill: false,
      //lineTension:1,
      radius: 3,

    },
  ];

  public options = {
    responsive: true,
    maintainAspectRatio: false,
    scale: {
      ticks: {
        beginAtZero: true,
        max: 100,
        min: 0,
        stepSize: 25,
        fontSize: 10,
       
      },
      pointLabels:{
        fontColor : '#000000',
        fontSize:10,
        fontFamily:'Roboto',
     },
    },
    legend: {
      align: "end",
      position: "bottom",
      display:true,
      labels: {
        fontColor: "#001A33",
        fontSize: 9,
        fontFamily:'Roboto',
        usePointStyle: true
      }
    },
    layout: {
      padding: {
          left: 2,
          right: 2,
          top: 2,
          bottom: 2
      },
      
  }
  };

  public optionsLargeScreen = {
    responsive: true,
    maintainAspectRatio: true,
    scale: {
      ticks: {
        beginAtZero: true,
        max: 100,
        min: 0,
        stepSize: 25,
        fontSize: 10,
      },
      pointLabels:{
        fontColor : '#000000',
        fontFamily:'Roboto',
        fontSize:12
     },
    },
    legend: {
      align: "end",
      position: "bottom",
      display:true,
      labels: {
        fontColor: "#001A33",
        fontSize: 10,
        fontFamily:'Roboto',
        usePointStyle: true,
      }
    },
    layout: {
      padding: {
          left: 2,
          right: 2,
          top: 2,
          bottom: 2
      },
      
  }
  };




  public radarChartType: string = 'radar';

  // events
  public chartClicked(e: any): void {
   // console.log(e);
  }

  public chartHovered(e: any): void {
    //console.log(e);
  }
}

